module.exports = __webpack_public_path__ + "img/ttf.b917b14f.png";